import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { IcTicket, FaIcon } from "../../Icons";

const ITEMS = [
  {
    label: "Módulos",
    icon:  "fas fa-cubes",
    color: "#6366f1",
    bg:    "#eef2ff",
    href:  "/ListadoModulos",
    desc:  "Categorías de tickets",
    perm:  "menu_gastos",
  },
  {
    label: "Tickets",
    icon:  "fas fa-ticket-alt",
    color: "#3b82f6",
    bg:    "#eff6ff",
    href:  "/ListadoTickets",
    desc:  "Solicitudes y seguimiento",
    perm:  "menu_gastos",
  },
];

function BotonesTickets() {
  const { user } = useContext(AuthContext);

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "20px 24px" }}>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8, background: "#eff6ff",
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "1px solid #bfdbfe",
          }}>
            <IcTicket style={{ color: "#3b82f6", fontSize: "1rem" }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
              Tickets
            </h3>
            <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
              Módulos y gestión de tickets
            </p>
          </div>
        </div>

        {user.menu_gastos ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              const enabled = !!user[r.perm];
              return (
                <div key={i} className="col-6 col-md-4 col-xl-3 mb-3">
                  <a
                    href={enabled ? r.href : undefined}
                    style={{
                      display:        "flex",
                      flexDirection:  "column",
                      alignItems:     "center",
                      gap:            10,
                      padding:        "22px 14px",
                      background:     "#fff",
                      borderRadius:   10,
                      boxShadow:      "0 1px 3px rgba(0,0,0,0.07)",
                      border:         "1px solid #f1f5f9",
                      textDecoration: "none",
                      color:          "#334155",
                      transition:     "box-shadow 0.15s, transform 0.15s",
                      textAlign:      "center",
                      opacity:        enabled ? 1 : 0.45,
                      pointerEvents:  enabled ? "auto" : "none",
                      cursor:         enabled ? "pointer" : "default",
                    }}
                    onMouseEnter={(e) => {
                      if (!enabled) return;
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{
                      width: 52, height: 52, borderRadius: 12,
                      background: r.bg,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      <FaIcon cls={r.icon} size={22} style={{ color: r.color }} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: "0.82rem", marginBottom: 2 }}>{r.label}</div>
                      <div style={{ fontSize: "0.7rem", color: "#94a3b8", lineHeight: 1.3 }}>{r.desc}</div>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        ) : (
          <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso a tickets.</p>
        )}
      </div>
    </>
  );
}

export default BotonesTickets;
